import { Routes, Route, Navigate } from "react-router-dom";
import {
  SendIdentityCodePage,
  PhoneNumberPage,
  PersonalInformationPage,
  AddressPage,
  OTPPage,
  HasRegisteredPage,
} from "./path-route/PathRoute";
import Start from "../pages/start/Start";
import PersonalInformation from "./../pages/personalInformation/PersonalInformation";
import Address from "./../pages/address/Address";
import SendIdentityCode from "./../pages/sendIdentityCode/SendIdentityCode";
import PhoneNumber from "../pages/phoneNumber/PhoneNumber";
import OTP from "../pages/otp/OTP";
import HasRegistered from "../pages/hasRegistered/HasRegistered";
export default function Router() {
  return (
    <>
      <Routes>
        <Route index element={<Start />} />
        <Route path="/fa" element={<Start />} />
        <Route path={SendIdentityCodePage} element={<SendIdentityCode />} />
        <Route path={PhoneNumberPage} element={<PhoneNumber />} />
        <Route path={OTPPage} element={<OTP />} />
        <Route
          path={PersonalInformationPage}
          element={<PersonalInformation />}
        />
        <Route path={AddressPage} element={<Address />} />
        <Route path={HasRegisteredPage} element={<HasRegistered />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
